import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import AdminBills from "@/components/Bills/AdminBills.vue";
import { IncomingBillService } from "@/services/IncomingBillService";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminBillsView',
  async setup(__props, { expose: __expose }) {
  __expose();

let __temp: any, __restore: any

const billService = new IncomingBillService();
const bills = ref<any[]>([]);

const fetchBills = async () => {
  bills.value = (await billService.getAll()) ?? [];
};

;(
  ([__temp,__restore] = _withAsyncContext(() => fetchBills())),
  await __temp,
  __restore()
);

const __returned__ = { billService, bills, fetchBills, AdminBills, get IncomingBillService() { return IncomingBillService }, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})